import {ApolloClient} from 'apollo-client';
import {ApolloLink} from 'apollo-link';
import {HttpLink} from 'apollo-link-http';
import {InMemoryCache, defaultDataIdFromObject} from 'apollo-cache-inmemory';
import {CHECKOUT_QUERY} from './queries';
import storage from '../helpers/storage';
import constants from '../helpers/constants';

const initApollo = (checkoutExperienceModel = {}) => {
    const cache = new InMemoryCache({
        dataIdFromObject: (object) => {
            switch (object.__typename) {
                case 'CheckoutExperienceModel':
                    return object.__typename;
                case 'HostContactDetail':
                    return object.__typename;
                default:
                    return defaultDataIdFromObject(object);
            }
        },
    });

    const graphqlEndPoint = window?.__INITIAL_STATE__?.stubMode.enableStubMode
        ? window?.__INITIAL_STATE__?.stubMode.path
        : '/cko/graphql';

    const client = new ApolloClient({
        cache,
        link: ApolloLink.from([
            new HttpLink({
                uri: graphqlEndPoint,
                credentials: 'same-origin',
                headers: {
                    'x-homeaway-requestmarker':
                        window?.__INITIAL_STATE__?.requestMarker,
                    'x-homeaway-site': window?.__INITIAL_STATE__?.site,
                    'x-homeaway-displaylocale':
                        window?.__INITIAL_STATE__?.system?.locale,
                    'x-csrf-jwt': window?.ha?.jwtCsrfToken,
                    'x-homeaway-thin-ui-ha-session':
                        window?.__INITIAL_STATE__?.haSession?.[
                            'X-HOMEAWAY-THIN-UI-HA-SESSION'
                        ],
                },
            }),
        ]),
    });

    /**
     * We currently have 4 different mutations/queries that all return a checkoutExperienceModel (quote, createCheckout, createVasCheckout, createPayment)
     * Ideally we'd have 1 query for all operations so the UI does not need to know which query to fetch depending on the flow. The below is a temp workaround
     * TODO:
     * Move this to the server and hydrate the cache. Also consider creating a single query for all create operations
     */
    if (JSON.stringify(checkoutExperienceModel) !== JSON.stringify({})) {
        client.writeQuery({
            query: CHECKOUT_QUERY,
            data: {
                checkoutExperienceModel,
            },
        });
    }
    /**
     * TODO: Deprecate the use of session storage in favor of the apollo cache so all flows can read from one data source
     * Purchaser info is stored in session storage for OLB and returned from the travelerInformation for OLP
     */
    if (checkoutExperienceModel.travelerInformation) {
        storage.set(
            constants.STORAGE.USER_CONTACT_DETAILS_OLP,
            Object.assign({}, checkoutExperienceModel.travelerInformation)
        );
    }

    return client;
};

export default initApollo;
